"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = findIndex;

function findIndex(a, b) {
  return a.findIndex(function (a) {
    var c = a.assetId;
    return b === c;
  });
}